import axios from "axios"
import { toast } from "~/toast"

var token = (
  document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement
).content

const client = axios.create({
  headers: { "X-CSRF-Token": token }
})

const handleError = (error: any) => {
  console.error(error)
  window.location.reload()
}

const backend = {
  updateDay: (dayId: number, params: any) => {
    client.put(`/days/${dayId}`, params).catch(function (error) {
      handleError(error)
    })
  },
  updateDiet: (dayId: number, diet: { weight?: string; calories?: string }) => {
    const savedLabel = diet.weight !== undefined ? "Weight" : "Calories"

    client
      .put(`/days/${dayId}`, { diet })
      .then(function () {
        toast.success(`${savedLabel} saved`)
      })
      .catch(function (error) {
        handleError(error)
      })
  },
  updateShoppingList: (params: any) => {
    client.post(`/shopping_lists`, params).catch(function (error) {
      handleError(error)
    })
  },
  updateRecipe: (recipeId: number, params: any) => {
    client.put(`/recipes/${recipeId}`, params).catch(function (error) {
      handleError(error)
    })
  },
  updateRecipePreparation: (id: number, recipeId: number, params: any) => {
    client
      .put(`/recipes/${recipeId}/preparations/${id}`, params)
      .catch(function (error) {
        handleError(error)
      })
  },
  updateWorkNotes: (dayId: number, notes: string) => {
    client
      .put(`/days/${dayId}`, {
        work_notes: notes
      })
      .catch(function (error) {
        handleError(error)
      })
  },
  updateThreeTasks: (
    dayId: number,
    tasks: { index: string; task: string; completed: boolean }[]
  ) => {
    client
      .put(`/days/${dayId}`, {
        three_tasks: tasks
      })
      .catch(function (error) {
        handleError(error)
      })
  },
  updateStickyNotes: (notes: any) => {
    client
      .put(`/users/sticky_notes`, { sticky_notes: notes })
      .catch(function (error) {
        handleError(error)
      })
  },
  updateWorkTasks: (
    dayId: number,
    tasks: { index: string; task: string; completed: boolean; level: number }
  ) => {
    client
      .put(`/days/${dayId}`, {
        work_tasks: tasks
      })
      .catch(function (error) {
        handleError(error)
      })
  },
  updateJournal: (id: number, params: any, onComplete: any) => {
    client
      .put(`/journals/${id}`, { journal: params })
      .then(onComplete)
      .catch(function (error) {
        // handleError(error)
        console.error(error)
      })
  },
  updateChain: (id: number, params: any, onComplete: any) => {
    client
      .post(`/chains/${id}/update_dates`, params)
      .then(onComplete)
      .catch(function (error) {
        handleError(error)
      })
  },
  addIngredientToShoppingList: async (ingredientName: string) => {
    return client.post(`/shopping_lists/add_item`, { item: ingredientName })
  }
}

export default backend
